export default __webpack_public_path__ + "static/media/wordpress.21216df8.png";